import * as React from "react";
import { style } from "glamor";
import SalesRep from "./sales-rep";

const Marketplace = ({ model }) => {
    const salesReps = model.salesReps.map((rep) => <SalesRep model={rep} key={rep._id} />);

    const styles = style({
        display: "flex",
        flexWrap: "wrap",
        flexGrow: 1,
        alignContent: "space-between",
        overflowY: "auto",
        maxHeight: "calc(100% - 90px)",
        paddingTop: "30px",
    });
    return <div {...styles}>{salesReps}</div>;
};

export { Marketplace };
export default Marketplace;
